// extracted by mini-css-extract-plugin
export default {"instruction":"UpdateContactPersonModal_instruction__xYX+O","updateBtn":"UpdateContactPersonModal_updateBtn__jfFWh","errorMessage":"UpdateContactPersonModal_errorMessage__ksViH"};